import React from 'react';
import analytics from '@ktag/styleguide/src/javascripts/analytics/analytics';
import { useTranslation } from 'react-i18next';
import { SearchBar } from '@ktag/styleguide/dist/react';
import Placeholder from './SwisscoverysearchPlaceholder';

// We expect proptype definitions including clearly
// marked required props. this will help developers understand
// and reuse your code
interface Props {
  searchUrl?: string;
}

// Use functional components
// We try to use functional components because classes are
// somewhat difficult for developers and machines alike. Also where possible
// try to separate your components into plain render components and components (potentially
// higher order components) with business logic.
const Swisscoverysearch = (props: Props) => {
  // How props work:
  // ID and additionalClassNames are generally expected props to offer
  // in a render component. This way, other consumers can reuse the component
  // and link to it by means of a hash or customize its looks by means of a custom
  // css class.
  const { searchUrl } = props;

  // How custom labels work
  // You can register any language or namespace with a map of translations
  // if you do not register a namespace using i18n.add, i18n will try to load
  // the labels via HTTP from the translation API.

  // Otherwise, you can use the translation API to load the labels by passing
  // the namespace of your app to the translation hook like this:
  const { t } = useTranslation('swisscoverysearch');

  const setQuery = (query: string) => {
    // clear will also trigger this
    if (query === '') return;

    const url = `${searchUrl}?vid=41SLSP_ABN:ABN&tab=ABN_AKB&search_scope=ABN_AKB&lang=de&query=any,contains,${query}`;
    analytics.trackEvent('Swisscovery', 'Search', { label: query });
    window.open(url, '_blank')?.focus(); // document.location.href = url;
  };

  return (
    <div className="swisscoverysearch" aria-labelledby="swisscoverysearch__title">
      <h2 id="swisscoverysearch__title" className="swisscoverysearch__title">
        {t('title')}
      </h2>
      <SearchBar
        placeholder={t('searchplaceholder')}
        search=""
        setSearch={setQuery}
        confirmToSubmit
      />
    </div>
  );
};

// Use default prop definitions rather than initialising defaults or
// sanitizing empty values inside your component logic.
Swisscoverysearch.defaultProps = {
  searchUrl: 'https://slsp-abn.primo.exlibrisgroup.com/discovery/search',
};

export default Swisscoverysearch;
export { Placeholder };
